import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { mobileBreakpoint } from 'shared/constants/styles'

export const Wrapper = styled.div`
  display: grid;
  padding: 1em;
  max-height: 400px;
  overflow: auto;

  button {
    width: 100%;
    border-radius: 0px;
    justify-content: start;
  }
  @media screen and (max-width: ${bp.medium}) {
    grid-template-columns: 100%;
  }
`
export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 2em;
  label {
    text-align: left;
    margin-bottom: 0;
  }
`

export const DropdownStyle = css`
  line-height: 1.2;

  + div {
    margin-right: 6px; // To avoid overlap with scrollbar
  }

  @media screen and (max-width: ${bp.medium}) {
    width: 100%;
    height: 36px;

    + div {
      width: calc(100% - 2em - 2px);
      margin-right: unset;
    }
  }
`

export const MultipleFiltersWrapper = styled.div(
  ({ templateColumns }: { templateColumns: string }) => css`
    display: grid;
    grid-template-columns: ${templateColumns};
    grid-gap: 1em;

    button {
      width: 100%;
    }

    @media screen and (max-width: ${mobileBreakpoint}px) {
      grid-template-columns: 1fr;
      width: 100%;
    }
  `
)
